document.addEventListener("DOMContentLoaded", function () {
    let collectionList = document.querySelector(".collection-list__items");
    let nextPageLink = document.getElementById("next-page");
    let container = document.querySelector(".collections-list .load-more-container");
    let scrollStorageKey = "collections-list-scroll";

    if (!collectionList || !container) {
        return;
    }

    let paginationType = container.dataset.paginationType || "click";
    let currentPage = parseInt(new URL(window.location.href).searchParams.get("page"), 10) || 1;
    let isLoading = false;

    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }

    window.addEventListener("pagehide", function () {
        sessionStorage.setItem(scrollStorageKey, JSON.stringify({
            url: window.location.href,
            y: window.scrollY
        }));
    });

    function getCollectionsHtml(html) {
        let doc = new DOMParser().parseFromString(html, "text/html");
        let list = doc.querySelector(".collection-list__items");
        return {
            items: list ? list.innerHTML : "",
            nextPage: doc.getElementById("next-page")
        };
    }

    function getPageUrl(page) {
        let url = new URL(window.location.href);
        url.searchParams.set("page", page);
        return url.toString();
    }

    function restoreScrollPosition() {
        let saved = null;

        try {
            saved = JSON.parse(sessionStorage.getItem(scrollStorageKey));
        } catch (error) {
            saved = null;
        }

        if (saved && saved.url === window.location.href) {
            window.scrollTo(0, saved.y);
        }
    }

    function restorePreviousPages() {
        if (currentPage <= 1) {
            restoreScrollPosition();
            return Promise.resolve();
        }

        let requests = [];
        for (let page = 1; page < currentPage; page++) {
            requests.push(fetch(getPageUrl(page)).then(function (response) {
                return response.text();
            }));
        }

        return Promise.all(requests)
            .then(function (pages) {
                let previousItems = pages.map(function (html) {
                    return getCollectionsHtml(html).items;
                }).join("");

                collectionList.insertAdjacentHTML("afterbegin", previousItems);
                restoreScrollPosition();
            })
            .catch(function (error) {
                console.error("Error restoring previous collections:", error);
            });
    }

    function appendNextCollections(html) {
        let result = getCollectionsHtml(html);

        if (result.items) {
            collectionList.insertAdjacentHTML("beforeend", result.items);
        }

        if (result.nextPage && result.nextPage.getAttribute("href")) {
            nextPageLink.setAttribute("href", result.nextPage.getAttribute("href"));
            return true;
        }

        nextPageLink.removeAttribute("href");
        return false;
    }

    function initPagination() {
        if (!nextPageLink || !nextPageLink.getAttribute("href")) {
            container.style.display = "none";
            return;
        }

        if (paginationType === "infinite") {
            initInfiniteScroll();
        } else {
            initLoadMoreButton();
        }
    }

    function initInfiniteScroll() {
        let loader = document.getElementById("infinite-scroll-loader");
        if (!loader) return;

        let observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !isLoading && nextPageLink && nextPageLink.getAttribute("href")) {
                    loadNextCollections();
                }
            });
        }, {
            root: null,
            rootMargin: "250px",
            threshold: 0.1
        });

        observer.observe(loader);

        function loadNextCollections() {
            let nextPageUrl = nextPageLink.getAttribute("href");
            if (!nextPageUrl) {
                observer.disconnect();
                loader.style.display = "none";
                container.style.display = "none";
                return;
            }

            isLoading = true;
            loader.style.display = "flex";
            container.style.display = "flex";

            let fetchPromise = fetch(nextPageUrl).then(function (response) {
                return response.text();
            });
            let minDelayPromise = new Promise(function (resolve) {
                setTimeout(resolve, 1000);
            });

            Promise.all([fetchPromise, minDelayPromise])
                .then(function (results) {
                    let hasMore = appendNextCollections(results[0]);

                    if (history && history.replaceState) {
                        history.replaceState(null, "", nextPageUrl);
                    }

                    if (!hasMore) {
                        observer.disconnect();
                        loader.style.display = "none";
                        container.style.display = "none";
                    }

                    isLoading = false;
                })
                .catch(function (error) {
                    console.error("Error loading more collections:", error);
                    observer.disconnect();
                    loader.style.display = "none";
                    container.style.display = "none";
                    isLoading = false;
                });
        }
    }

    function initLoadMoreButton() {
        let loadMoreBtn = document.getElementById("load-more");
        if (!loadMoreBtn) return;

        loadMoreBtn.addEventListener("click", function () {
            if (isLoading || !nextPageLink) return;

            let nextPageUrl = nextPageLink.getAttribute("href");
            if (!nextPageUrl) {
                loadMoreBtn.style.display = "none";
                container.style.display = "none";
                return;
            }

            isLoading = true;
            loadMoreBtn.textContent = "Loading...";

            fetch(nextPageUrl)
                .then(function (response) {
                    return response.text();
                })
                .then(function (html) {
                    let hasMore = appendNextCollections(html);

                    if (history && history.replaceState) {
                        history.replaceState(null, "", nextPageUrl);
                    }

                    if (hasMore) {
                        loadMoreBtn.textContent = "Load More";
                    } else {
                        loadMoreBtn.style.display = "none";
                        container.style.display = "none";
                    }

                    isLoading = false;
                })
                .catch(function (error) {
                    console.error("Error loading more collections:", error);
                    loadMoreBtn.textContent = "Load More";
                    isLoading = false;
                });
        });
    }

    restorePreviousPages().then(initPagination);
});
